import messages from './messages';

const schema = ({ intl }: any) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultFieldset),
      fields: [
        'eyebrow',
        'heading',
        'price',
        'price_note',
        'service_note',
        'closing_note',
        'image',
        'show_allergen_notice',
      ],
    },
    {
      id: 'courses',
      title: intl.formatMessage(messages.coursesFieldset),
      fields: ['courses'],
    },
  ],
  properties: {
    eyebrow: { title: intl.formatMessage(messages.eyebrow), type: 'string' },
    heading: { title: intl.formatMessage(messages.heading), type: 'string' },
    price: { title: intl.formatMessage(messages.price), type: 'string' },
    price_note: {
      title: intl.formatMessage(messages.priceNote),
      type: 'string',
    },
    service_note: {
      title: intl.formatMessage(messages.serviceNote),
      description: intl.formatMessage(messages.serviceNoteDescription),
      type: 'string',
    },
    closing_note: {
      title: intl.formatMessage(messages.closingNote),
      type: 'string',
    },
    image: {
      title: intl.formatMessage(messages.image),
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
      description: intl.formatMessage(messages.imageDescription),
    },
    show_allergen_notice: {
      title: intl.formatMessage(messages.showAllergenNotice),
      type: 'boolean',
      default: false,
    },
    courses: {
      title: intl.formatMessage(messages.courses),
      type: 'array',
      widget: 'object_list',
      schema: {
        title: intl.formatMessage(messages.course),
        addMessage: intl.formatMessage(messages.addCourse),
        fieldsets: [
          {
            id: 'default',
            title: intl.formatMessage(messages.course),
            fields: ['label', 'choices'],
          },
        ],
        properties: {
          label: {
            title: intl.formatMessage(messages.courseLabel),
            type: 'string',
          },
          choices: {
            title: intl.formatMessage(messages.choices),
            type: 'array',
            widget: 'object_list',
            schema: {
              title: intl.formatMessage(messages.choice),
              addMessage: intl.formatMessage(messages.addChoice),
              fieldsets: [
                {
                  id: 'default',
                  title: intl.formatMessage(messages.choice),
                  fields: ['title'],
                },
              ],
              properties: {
                title: {
                  title: intl.formatMessage(messages.choiceTitle),
                  type: 'string',
                },
              },
              required: [],
            },
          },
        },
        required: [],
      },
    },
  },
  required: [],
});

export default schema;
